import { render } from "./UploadFilePage.vue?vue&type=template&id=dea18730&scoped=true"
import script from "./UploadFilePage.vue?vue&type=script&lang=js"
export * from "./UploadFilePage.vue?vue&type=script&lang=js"

import "./UploadFilePage.vue?vue&type=style&index=0&id=dea18730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea18730"]])

export default __exports__